import React from "react";

const DocLists = ({
  docs,
  keyLabel,
  bgColor = "#E9EAF8",

  onDocClick = (doc) => window.open(doc),
}) => {
  return (
    <div className={`text-sm text-gray-600 bg-[${bgColor}] rounded-md p-2`}>
      <ul className="list-none ml-6 ">
        {docs.map((doc, dIndex) => {
          const labelDoc = keyLabel ? doc[keyLabel] : `${doc}`;
          return (
            <li
              key={`doc-${dIndex}`}
              className="mb-3 cursor-pointer"
              onClick={() => onDocClick(doc)}
            >
              <div className="flex gap-2 align-middle">
                <img src="/images/icons/folder.svg" alt={labelDoc}  width={20} height={20}/>
                <h6 className="text-base">{labelDoc}</h6>
              </div>
              {doc?.description && <p className="text-xs">{doc.description}</p>}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DocLists;
